import { render, staticRenderFns } from "./AdminTransferAmounts.vue?vue&type=template&id=3edeb82a&scoped=true"
import script from "./AdminTransferAmounts.vue?vue&type=script&lang=js"
export * from "./AdminTransferAmounts.vue?vue&type=script&lang=js"
import style0 from "./AdminTransferAmounts.vue?vue&type=style&index=0&id=3edeb82a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edeb82a",
  null
  
)

export default component.exports